import { CustomerCommitmentUsageSection } from '../data-dashboard-components/customer-commitment-usage/customer-commitment-usage-section';
import { EventsDigestedSection } from '../data-dashboard-components/events-digested-section/events-digested-section';
import { RevenueByCurrencySection } from '../data-dashboard-components/revenue-by-currency-section/revenue-by-currency-section';
import { RevenueSection } from '../data-dashboard-components/revenue-section/revenue-section';
import { UsageByMeterSection } from '../data-dashboard-components/usage-by-meter-section/usage-by-meter-section';

export const HomePageDataDashboardTabContent = () => {
  return (
    <>
      <RevenueSection />

      <RevenueByCurrencySection />

      <EventsDigestedSection />
      
      <UsageByMeterSection />
      
      <CustomerCommitmentUsageSection />
    </>
  );
};